import React from "react";
import { CloudIcon, FogIcon, RainIcon, SnowIcon, SunIcon } from "../icons/WeatherIcons";

export const WeatherSideCards = ({ weatherData }) => {
  const weatherCode = weatherData.weatherCode || 0;

  const getWeatherDescription = (code) => {
    if (code >= 71 && code <= 77) return "Snowy";
    if ((code >= 51 && code <= 67) || (code >= 80 && code <= 82)) return "Rainy";
    if (code === 2 || code === 3) return "Partly Cloudy";
    if (code === 45 || code === 48) return "Foggy";
    return "Clear";
  };

  const getMainIconType = (code) => {
    if (code >= 71 && code <= 77) return "snow";
    if ((code >= 51 && code <= 67) || (code >= 80 && code <= 82)) return "rain";
    if (code === 2 || code === 3) return "cloud";
    if (code === 45 || code === 48) return "fog";
    return "sun";
  };

  const description = getWeatherDescription(weatherCode);
  const mainIconType = getMainIconType(weatherCode);

  const sunrise =
    weatherData.sunrise != null
      ? new Date(weatherData.sunrise).toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        })
      : null;
  const sunset =
    weatherData.sunset != null
      ? new Date(weatherData.sunset).toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        })
      : null;

  return (
    <div className="flex sm:justify-end m:flex-row gap-4 xl:gap-3">
      <div className="flex-1 grid gap-3 rounded-xl p-4 bg-[#456ec1] text-white shadow-sm">
        <div className="mb-2 text-white">
          {mainIconType === "rain" ? (
            <RainIcon className="w-16 h-16" title="Rain" />
          ) : mainIconType === "cloud" ? (
            <CloudIcon className="w-16 h-16" title="Cloud" />
          ) : mainIconType === "fog" ? (
            <FogIcon className="w-16 h-16" title="Fog" />
          ) : mainIconType === "sun" ? (
            <SunIcon className="w-16 h-16" title="Sun" />
          ) : (
            <SnowIcon className="w-16 h-16" title="Snow" />
          )}
        </div>
        <p className="text-md text-white/95">{description}</p>
        <p className="text-md text-white/90">Sunrise: {sunrise}</p>
        <p className="text-md text-white/90">Sunset: {sunset}</p>
      </div>

      <div className="flex-1 grid gap-3 rounded-xl p-4 bg-[#1f4a73] text-white shadow-sm">
        <p className="text-md font-bold mb-1 tracking-wide">MORE DETAILS</p>

        <div className="flex items-center gap-3">
          <span className="inline-flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              className="w-6 h-6 fill-current"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320zM384 416C384 389.1 367.5 366.1 344 356.7L344 184C344 170.7 333.3 160 320 160C306.7 160 296 170.7 296 184L296 356.7C272.5 366.2 256 389.2 256 416C256 451.3 284.7 480 320 480C355.3 480 384 451.3 384 416z" />
            </svg>
          </span>
          <p className="text-md opacity-95">Pressure: {weatherData.pressure}mb</p>
        </div>

        <div className="flex items-center gap-3">
          <span className="inline-flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              className="w-6 h-6 fill-current"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M320 96C239.2 96 174.5 132.8 127.4 176.6C80.6 220.1 49.3 272 34.4 307.7C31.1 315.6 31.1 324.4 34.4 332.3C49.3 368 80.6 420 127.4 463.4C174.5 507.1 239.2 544 320 544C400.8 544 465.5 507.2 512.6 463.4C559.4 419.9 590.7 368 605.6 332.3C608.9 324.4 608.9 315.6 605.6 307.7C590.7 272 559.4 220 512.6 176.6C465.5 132.9 400.8 96 320 96zM176 320C176 240.5 240.5 176 320 176C399.5 176 464 240.5 464 320C464 399.5 399.5 464 320 464C240.5 464 176 399.5 176 320zM320 256C320 291.3 291.3 320 256 320C244.5 320 233.7 317 224.3 311.6C223.3 322.5 224.2 333.7 227.2 344.8C240.9 396 293.6 426.4 344.8 412.7C396 399 426.4 346.3 412.7 295.1C400.5 249.4 357.2 220.3 311.6 224.3C316.9 233.6 320 244.4 320 256z" />
            </svg>
          </span>
          <p className="text-md opacity-95">Visibility: {weatherData.visibility}km</p>
        </div>

        <div className="flex items-center gap-3">
          <span className="inline-flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              className="w-6 h-6 fill-current"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M320 576C214 576 128 490 128 384C128 292.8 258.2 109.9 294.6 60.5C300.5 52.5 309.8 48 319.8 48L320.2 48C330.2 48 339.5 52.5 345.4 60.5C381.8 109.9 512 292.8 512 384C512 490 426 576 320 576zM240 376C240 362.7 229.3 352 216 352C202.7 352 192 362.7 192 376C192 451.1 252.9 512 328 512C341.3 512 352 501.3 352 488C352 474.7 341.3 464 328 464C279.4 464 240 424.6 240 376z" />
            </svg>
          </span>
          <p className="text-md opacity-95">Humidity: {weatherData.humidity}%</p>
        </div>

        <div className="flex items-center gap-3">
          <span className="inline-flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              className="w-6 h-6 fill-current"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M352 96C352 113.7 366.3 128 384 128L424 128C437.3 128 448 138.7 448 152C448 165.3 437.3 176 424 176L96 176C78.3 176 64 190.3 64 208C64 225.7 78.3 240 96 240L424 240C472.6 240 512 200.6 512 152C512 103.4 472.6 64 424 64L384 64C366.3 64 352 78.3 352 96zM416 448C416 465.7 430.3 480 448 480L480 480C533 480 576 437 576 384C576 331 533 288 480 288L96 288C78.3 288 64 302.3 64 320C64 337.7 78.3 352 96 352L480 352C497.7 352 512 366.3 512 384C512 401.7 497.7 416 480 416L448 416C430.3 416 416 430.3 416 448zM192 576L232 576C280.6 576 320 536.6 320 488C320 439.4 280.6 400 232 400L96 400C78.3 400 64 414.3 64 432C64 449.7 78.3 464 96 464L232 464C245.3 464 256 474.7 256 488C256 501.3 245.3 512 232 512L192 512C174.3 512 160 526.3 160 544C160 561.7 174.3 576 192 576z" />
            </svg>
          </span>
          <p className="text-md opacity-95">Wind Speed: {weatherData.windSpeed}km/h</p>
        </div>
      </div>
    </div>
  );
};

export default WeatherSideCards;


